// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_gd-6";
export var emphasizeQuantity = "_gd-3";
export var flatBottomCorners = "_gd-5";
export var productImage = "_gd-0";
export var quantityContainer = "_gd-2";
export var tooltip = "_gd-1";
export var wrapAndEllipsesOverflow = "_gd-4";